import { Z_INDEX_UI } from '@/constant';
import { styled, Typography } from '@mui/material';

export const ComponentLabel = styled(Typography)(({ theme }) => [
    {
        zIndex: Z_INDEX_UI,
        pointerEvents: 'auto',
        userSelect: 'none',
        position: 'absolute',
        transform: 'translateY(-100%)',
        top: -4,
        borderRadius: 4,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        backgroundColor: (theme.vars || theme).palette.grey[100],
        color: (theme.vars || theme).palette.text.primary,
        whiteSpace: 'nowrap',
    },
    theme.applyStyles('dark', {
        backgroundColor: (theme.vars || theme).palette.grey[800],
    }),
]);
